import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectPartnumbersService} from "@catmodels/project-partnumbers/services/project-partnumbers.service";
import {ProjectService} from "@catcore/services";
import {isNullOrUndefined} from "util";
import {ExplorerItem, TreeNodeInfo} from "@catui/types";
import {Router} from "@angular/router";
import {Project} from "@catcore/types/api-v2";

@Component({
  selector: 'cat-project-partnumbers',
  templateUrl: './project-partnumbers.component.html',
  styleUrls: ['./project-partnumbers.component.scss']
})
export class ProjectPartnumbersComponent implements OnInit,  OnDestroy {
  doAllowCreate = false;
  activeItem = false;
  explorerItems: ExplorerItem[] = [];
  subscription = null;

  constructor(private projectService: ProjectService,
              private router: Router,
              private projectPartnumbersService: ProjectPartnumbersService) {
  }

  navigateTo(node: TreeNodeInfo) {
    this.router.navigate(node.item.value.route);

  }

  ngOnInit() {
    this.subscription = this.projectService
      .getCurrentProject()
      .subscribe((project: Project) => {
        if (!isNullOrUndefined(project)) {
          this.explorerItems = [];
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Units', 'units'));
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Services', 'services'));
        }
      });
    this.projectPartnumbersService.setActive();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.projectPartnumbersService.setInActive();
  }
}

const buildDefaultExplorerItem = (project: Project, displayName: string, targetRef: string): ExplorerItem => {
  return {label: displayName, value: {route: ['projects', `${project.id}`, 'partnumbers', targetRef]}, expanded: false, allowedActions: []};
};




// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/project-partnumbers/components/project-partnumbers/project-partnumbers.component.ts